import { Box } from "@mantine/core"
import type { PropsWithChildren } from "react"
import { ActivitiesOnly, AdminOnly } from "@/components/utils"
import { checkSurvey, type TActivity } from "@/types"
import { useScheduleActivity } from "./hooks/useScheduleActivity"
import type { TScheduleProps } from "./types"

export function ScheduleActivityWrapper({ children, ...props }: PropsWithChildren<TScheduleProps>) {
  const { open } = useScheduleActivity(props)
  const isSurvey = checkSurvey({ type: props.activityType as TActivity["type"] })

  const content = (
    <Box
      onClick={(e) => {
        e.stopPropagation()
        open()
      }}
    >
      {children}
    </Box>
  )

  return isSurvey ? (
    <ActivitiesOnly type={props.activityType as TActivity["type"]}>{content}</ActivitiesOnly>
  ) : (
    <AdminOnly>{content}</AdminOnly>
  )
}
